import './styles/index.scss';

import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import RouteApp from './router';
import { getSocket } from './integrations/socket-io';

const socket = getSocket();
socket.connect();

let reconnecting = false;
const handleReconnect = () => {
  if (!socket.connected && !reconnecting) {
    reconnecting = true;
    console.log('🔄 reconnecting...');
    socket.connect();
    setTimeout(() => {
      reconnecting = false;
    }, 2000);
  }
};

window.addEventListener('focus', handleReconnect);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    handleReconnect();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
  <RouteApp />
);
